var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class GpuContext {
    constructor(gpu, adapter, device) {
        this.gpu = gpu;
        this.adapter = adapter;
        this.device = device;
    }
    static create() {
        return __awaiter(this, void 0, void 0, function* () {
            const gpu = navigator.gpu;
            if (!gpu) {
                return Promise.reject("WebGPU not supported on this browser! (navigator.gpu is null)");
            }
            const adapter = yield gpu.requestAdapter();
            if (!adapter) {
                return Promise.reject("WebGPU not supported on this browser! (gpu.adapter is null)");
            }
            const device = yield adapter.requestDevice({ label: "GPUDevice" });
            return new GpuContext(gpu, adapter, device);
        });
    }
    destroy() {
        this.device.destroy();
        this.adapter = null;
        this.device = null;
    }
}
